<footer class="axis-footer">
<div></div>
  @if(isCountryLanguageSelected()){
    <div class="axis-content-wrapper">
    <div class="axis-container-fluid">
      <ul class="axis-list-inline">
        @for (country of regularFooterLinks; track country) {
        <li>
          <a
            class="_cursor-pointer"
            (click)="handleFooterClick(country)"
          >{{country.label}}</a>
        </li>
        }
        <li>
          <a
            class="_cursor-pointer"
            (click)="linkForRecommended()"
          >{{cache.getTranslationRecommended()}}</a>
        </li>
        @if (lastFooterLink) {
        <li>
          <a
            class="_cursor-pointer"
            (click)="handleFooterClick(lastFooterLink)"
          >{{lastFooterLink.label}}</a>
        </li>
        }
      </ul>
      
      @if (copyrightText) {
      <p class="axis-footer-copyright"> {{ copyrightText }} </p>
      }
      @if (disclaimerText) {
      <p class="axis-footer-copyright"> {{ disclaimerText }} </p>
      }
    </div>
  </div>
  }
  
</footer>